import { useId } from 'react';
import {
  InsertFieldMenu,
  TokenField,
  useFieldInsertion,
  type InsertOption,
  type Segment,
} from '@/shared/components';

interface Props {
  label: string;
  /** Vorgelesen hinter dem Namen, damit „Titel“ in beiden Sprachen unterscheidbar bleibt. */
  language: string;
  value: string;
  placeholder: string;
  singleLine: boolean;
  maxLength: number;
  required?: boolean;
  hint?: string;
  options: InsertOption[];
  segments: Segment[];
  onChange: (value: string) => void;
}

/** Ein Text der Anfahrt: Felder hervorgehoben, eingefügt per Knopf oder durch Tippen von `{{`. */
export function ArrivalTextField(props: Props) {
  const id = useId();
  const insertion = useFieldInsertion(props.value, props.onChange);
  return (
    <div className="space-y-1.5">
      <div className="flex min-h-11 flex-wrap items-center justify-between gap-2">
        <label htmlFor={id} className="text-ink text-sm font-semibold">
          {props.label}
          <span className="sr-only"> ({props.language})</span>
          {props.required && <span className="text-sealwax ml-0.5">*</span>}
        </label>
        <InsertFieldMenu
          fieldLabel={props.label}
          options={props.options}
          open={insertion.menuOpen}
          onOpenChange={insertion.onMenuOpenChange}
          onInsert={insertion.insert}
          onCloseFocus={insertion.refocus}
        />
      </div>
      <TokenField
        ref={insertion.input}
        id={id}
        value={props.value}
        placeholder={props.placeholder}
        segments={props.segments}
        singleLine={props.singleLine}
        maxLength={props.maxLength}
        invalid={false}
        describedBy={props.hint ? `${id}-hint` : undefined}
        onChange={props.onChange}
        onFieldTrigger={insertion.onFieldTrigger}
      />
      {props.hint && (
        <p id={`${id}-hint`} className="text-ink-soft text-xs">
          {props.hint}
        </p>
      )}
    </div>
  );
}
